import React from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {ProductsLineFeature} from "./ProductsLineFeature";
import {observer} from "mobx-react";
import useFeature from "../../../useFeature";
import {PRODUCT_DETAIL_PATH, PRODUCTS_LINE_PATH} from "../../../routes";
import {useApplication} from "../../../ApplicationProvider";
import AddProductToCartButton from "../detail/AddProductToCartButton";
import {SelectDeliveryPointFeature} from "../detail/SelectDeliveryPointFeature";

const ProductsLineScreen = () => {
    const {id} = useParams()
    const application = useApplication()
    const feature = useFeature(() => new ProductsLineFeature(application, id), [id])
    const navigator = useNavigate();
    const deliverySiteFeature = useFeature(() => new SelectDeliveryPointFeature(application));

    const isFeatureReady = () => {
        return feature && feature.loaded;
    }

    const renderFamiliasNav = (position) => (
        <nav
            className={`navbar navbar-default navbar-justify navbar-secondary hidden-xs ${position === 'bottom' ? 'navbar-categories-bottom' : ''}`}>
            <div className="container">
                <div className="navbar-header">
                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                            data-target="#bs-example-navbar-collapse-1">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </button>
                </div>
                <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul className="nav navbar-nav" style={{
                        display: "flex",
                        // flexWrap: "wrap",
                        justifyContent: "left",
                        gap: "0px",
                        padding: "0",
                        margin: "0 auto",
                        maxWidth: "100%"}}>
                        {feature.families().map(item => (
                            <li key={item.Id} className={item.Id === feature.familyId().Id ? 'active' : ''}>
                                <Link to={PRODUCTS_LINE_PATH + `/${item.Id}`}>
                                    <img src={item.Archivos} className={"img-responsive family-logo-nav"} alt="Logo Dolce Sapore"/>
                                </Link>
                                {position === 'bottom' && <div className="arrow-up"></div>}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </nav>
    );
    return (isFeatureReady() &&
        <div>
            {renderFamiliasNav('top')}
            <div className="sdp-familia-hero" style={{backgroundImage: `url(${feature.familyBanner()})`}}>
                <div className="gradient"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="text-center margintop40">
                                <img src={feature.familyLogo()} className="img-responsive family-logo-line"
                                     alt="Logo Dolce Sapore"/>
                                <p className="title-hero hidden-xs" style={{ fontFamily: 'ArcherSmbd, sans-serif' , fontWeight: 'bold'}}>{feature.familyTitle()}</p>
                                <div className="subtitle-hero hidden-xs" style={{ fontFamily: 'ArcherSmbd, sans-serif'}}>{feature.familyDescription()}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    {feature.articles().filter(article => !article.EsDemo).map(item => (
                        <div className="col-xs-12 col-sm-6 col-md-4" key={item.Id}>
                            <div className="product-item relative">
                                <Link to={PRODUCT_DETAIL_PATH + `/${item.Id}`} className="img-box">
                                    <img src={item.Producto.Archivos} className="img-responsive img-producto-categoria"
                                         alt="Foto de Categoría"/>
                                </Link>
                                <div className="footer-product">
                                    <Link to={PRODUCT_DETAIL_PATH + `/${item.Id}`}
                                          className="h5 title-product show">{item.Producto.NombreFantasia}</Link>
                                    {feature.canAddProduct() &&
                                        <AddProductToCartButton
                                            productId={item.Id}
                                            application={application}
                                            navigator={navigator}
                                            deliverySiteFeature={deliverySiteFeature}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {renderFamiliasNav('bottom')}
            <hr className="visible-xs divider-line footer-line"/>
        </div>
    );
};

export default observer(ProductsLineScreen);
